import * as types from '../store/mutation-types';
import SupportClient from './SupportClient';
import RegistrationClient from '../registration/RegistrationClient';

const state = {
    registrations: [],
    loadedRegistration: {},
    loadedUsage: {},
    isLoading: false
};

const getters = {
    registrations: state => {
        return state.registrations;
    },

    loadedRegistration: state => {
        return state.loadedRegistration;
    },

    isLoading: state => {
        return state.isLoading;
    },

    loadedUsage: state => {
        return state.loadedUsage;
    }
};

const actions = {
    registrations({ commit }, { state }) {
        commit(types.SET_REGISTRATIONS, []);
        commit(types.SET_LOADING_FLAG, true);
        SupportClient.getRegistrationsByState(state).then(result => {
            commit(types.SET_REGISTRATIONS, result.data);
            commit(types.SET_LOADING_FLAG, false);
        });
    },

    loadRegistrationById({ commit }, { id }) {
        SupportClient.loadRegistrationById(id).then(result => {
            commit(types.LOAD_REGISTRATION, result.data);
        });
    },

    loadUsageByInstance({ commit }, { instance }) {
        SupportClient.loadUsageByInstance(instance).then(result => {
            commit(types.LOAD_USAGE, result.data);
        });
    },

    noDuplicate({ commit }, { id }) {
        SupportClient.setRegistrationState(id, 'no-duplicate').then(result => {
            commit(types.LOAD_REGISTRATION, result.data);
        });
    },

    isDuplicate({ commit }, { id, sendMail }) {
        SupportClient.setRegistrationState(id, 'duplicate', sendMail).then(result => {
            commit(types.LOAD_REGISTRATION, result.data);
        });
    },

    markDone({ commit }, { id, comment }) {
        SupportClient.markDone(id, comment).then(result => {
            commit(types.LOAD_REGISTRATION, result.data);
        });
    },

    proceedInstallation({ commit }, { id, validationToken, comment }) {
        RegistrationClient.validateEmail(validationToken).then(() => {
            if (comment) {
                SupportClient.addComment(id, comment).then(() => {
                    SupportClient.loadRegistrationById(id).then(result => {
                        commit(types.LOAD_REGISTRATION, result.data);
                    });
                });
            } else {
                SupportClient.loadRegistrationById(id).then(result => {
                    commit(types.LOAD_REGISTRATION, result.data);
                });
            }
        });
    },

    addComment({ commit }, { id, comment }) {
        SupportClient.addComment(id, comment).then(() => {
            SupportClient.loadRegistrationById(id).then(result => {
                commit(types.LOAD_REGISTRATION, result.data);
            });
        });
    }
};

const mutations = {
    [types.SET_REGISTRATIONS](state, registrations) {
        state.registrations = registrations;
    },

    [types.LOAD_REGISTRATION](state, registration) {
        state.loadedRegistration = registration;
    },

    [types.SET_LOADING_FLAG](state, isLoading) {
        state.isLoading = isLoading;
    },

    [types.LOAD_USAGE](state, usage) {
        state.loadedUsage = usage;
    }
};

const namespaced = true;

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced
};
